
import { colors, fontSize, size } from '@styles/theme'
import styled from '@emotion/styled'

import { SliderTitle } from './SharedNearbyFilterComponents'
import { Slider } from '@elements/form_elements/Slider'
import { ButtonBase } from '@mui/material'
import { PiX } from 'react-icons/pi'

const ValueContainer = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: ${size(3)};
  justify-content: space-between;
  width: 100%;
  line-height: ${fontSize('sm')};
`

const ValueRange = styled.span`
  color: ${colors.statusColors['right_now']('light')};
`

const ClearButton = styled(ButtonBase)`
  position: absolute;
  right: 0;
  top: ${size(-0.7)};

  padding: ${size(0.35)} ${size(1)};
  margin: 0;

  border: 1px solid grey;
  border-radius: 100px;
`

const renderValue = (props, resetValue, isInactive, title, renderValueRangeText=(() => {})) => {
  return (
    <ValueContainer>
      <SliderTitle>
        {title}
        &nbsp;
        <ValueRange style={isInactive ? { color: 'grey' } : {}} >
          {renderValueRangeText(props)}
        </ValueRange>
      </SliderTitle>
      {!isInactive &&
        <ClearButton onClick={resetValue}>
          <PiX style={{ marginRight: 2 }}/>
          clear
        </ClearButton>
      }
    </ValueContainer>
  )
}


const sliderSlotProps = (isInactive) => ({
  control: {
    style: {
      paddingLeft: size(1.5),
      paddingRight: size(1.5),
    }
  },
  track: {
    style: {
      height: size(1.75),
      borderRadius: 100,
    }
  },
  indicator: {
    style: {
      height: size(1.75),
      backgroundColor: !isInactive && colors.statusColors['right_now']('lightRgba')(0.8),
      // backgroundColor: !isInactive && colors.statusColors['right_now']('primary') + '8c'
    }
  },
  thumbs: {
    style: {
      height: size(3.75),
      width: size(3.75),
      backgroundColor: isInactive && '#333333',
      border: '0.5px solid rgba(255,255,255, 0.15)',
    }
  },
})

const NearbyFilterSlider = ({ resetValue, isInactive, title, renderValueRangeText, ...rest }) => {
  return (
    <Slider
      renderSliderValue={(props) => renderValue(props, resetValue, isInactive, title, renderValueRangeText)}
      slotProps={sliderSlotProps(isInactive)}
      {...rest}
    />
  )
}

export { NearbyFilterSlider }
